import React from "react";
import Map from "../common/Map";
import { useI18n } from "../../hooks/useI18n";
import { buildNavigationUrl, detectNavigationPlatform } from "../../utils/navigation.utils";

interface MapSectionProps {
  coordinates?: { latitude: number; longitude: number };
  address?: string;
  name: string;
  height?: string;
}

const validCoordinates = (
  coordinates?: { latitude: number; longitude: number }
): coordinates is { latitude: number; longitude: number } =>
  Boolean(
    coordinates &&
      Number.isFinite(coordinates.latitude) &&
      Number.isFinite(coordinates.longitude) &&
      coordinates.latitude >= -90 && coordinates.latitude <= 90 &&
      coordinates.longitude >= -180 && coordinates.longitude <= 180
  );

const MapSection: React.FC<MapSectionProps> = ({ coordinates, address, name, height = "320px" }) => {
  const { text } = useI18n();

  if (!validCoordinates(coordinates)) {
    return address?.trim() ? <p className="text-center text-muted-foreground">{address}</p> : null;
  }

  const browser = typeof navigator === "undefined" ? undefined : navigator;
  const platform = detectNavigationPlatform({
    userAgent: browser?.userAgent,
    platform: browser?.platform,
    maxTouchPoints: browser?.maxTouchPoints,
  });
  const navigationUrl = buildNavigationUrl(coordinates, platform);

  return (
    <Map
      markers={[{
        lat: coordinates.latitude,
        lng: coordinates.longitude,
        title: name,
        description: address,
        navigationUrl,
        navigationLabel: text.business.openDirections,
      }]}
      single
      height={height}
    />
  );
};

export default MapSection;
